import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { FilePdfOutlined, EyeOutlined } from '@ant-design/icons';
import { BASE_URL } from 'helpers/api_helper';

const validExts = ["jpeg", "jpg", "png", "pdf"];

const FilePreview = ({ paymentImage }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [url, setUrl] = useState(null);
    const [isHovered, setIsHovered] = useState(false);

    // Nettoyage et construction de l'URL à partir de paymentImage
    useEffect(() => {
        setUrl(null);
        if (paymentImage) {
            const cleanApiUrl = BASE_URL?.replace(/\/+$/, '');
            let cleanPhoto = paymentImage?.replace(/^\/+/, '');
            cleanPhoto = paymentImage?.split('/')?.pop();
            if (!cleanPhoto?.includes('uploads/')) {
                cleanPhoto = 'uploads/' + cleanPhoto;
            }
            setUrl(`${cleanApiUrl}/${cleanPhoto}`);
        }
    }, [paymentImage]);

    const path = paymentImage?.replace(/\\/g, '/');
    const extMatch = path?.match(/\.([^.]+)$/);
    const ext = extMatch ? extMatch[1]?.toLowerCase() : "";

    const isImage = ["jpeg", "jpg", "png"].includes(ext);
    const isPdf = ext === "pdf";

    if (!validExts?.includes(ext)) {
        return <p>Type de fichier non pris en charge : .{ext}</p>;
    }

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: 24,
                marginTop: 24,
            }}
        >
            {isImage && url && (
                <div
                    style={{
                        position: 'relative',
                        maxWidth: 200,
                        maxHeight: 400,
                        cursor: 'pointer',
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <img
                        src={url}
                        alt="Justificatif de paiement"
                        style={{
                            display: 'block',
                            maxHeight: 400,
                            maxWidth: 200,
                            objectFit: 'contain',
                        }}
                        onClick={() => setModalOpen(true)}
                    />
                    {isHovered && (
                        <EyeOutlined
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                fontSize: 36,
                                color: 'rgba(255, 255, 255, 0.8)',
                            }}
                        />
                    )}
                </div>
            )}

            {isPdf && (
                <div
                    style={{ cursor: 'pointer', textAlign: 'center' }}
                    onClick={() => setModalOpen(true)}
                >
                    <FilePdfOutlined style={{ fontSize: 68, color: '#ff4d4f' }} />
                    <p>Voir le PDF</p>
                </div>
            )}

            <Modal
                open={modalOpen}
                title={isPdf ? 'Aperçu du PDF' : 'Aperçu de l’image'}
                footer={null}
                width="80vw"
                style={{ top: 20 }}
                onCancel={() => setModalOpen(false)}
                bodyStyle={{ height: '80vh', padding: 0 }}
                destroyOnClose
            >
                {isPdf && url && (
                    <iframe
                        src={url}
                        title="Aperçu PDF"
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                    />
                )}
                {isImage && url && (
                    <div
                        style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: '#000', // optionnel, pour contraster l'image
                        }}
                    >
                        <img
                            src={url}
                            alt="Aperçu Justificatif de paiement"
                            style={{
                                maxHeight: '100%',
                                maxWidth: '100%',
                                objectFit: 'contain',
                            }}
                        />
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default FilePreview;
